import { ColumnGroupTypes, DYN_FLAG } from 'src/helpers/modular/detailedSummaryReport/interfaces';
import { contractOverUnderColumn, extraWorkColumn, freeDaysColumnGroup, freeTimeColumnGroup, individualNormColumnGroup, overUnderColumn, periodNormColumnGroup, trainingColumn, userActualColumnGroup, userDataColumnGroup, watchColumn, workTimeColumnGroup } from 'src/helpers/modular/detailedSummaryReport/models';
import Utils from 'src/utils';
const { decapitalize } = Utils.strings;
class ColumnGroupsParser {
    static dynamicWorksSource;
    static dynamicExtrasSource;
    static absencesSource;
    static parse(rawReport) {
        this.dynamicWorksSource = rawReport.Departments?.[0]?.Users?.[0]?.CalculatedWorkHours?.CalculatedDynamicWorkHours?.Values || [];
        this.dynamicExtrasSource = rawReport.Departments?.[0]?.Users?.[0]?.CalculatedWorkHours?.CalculatedDynamicExtraHours?.Values || [];
        this.absencesSource = rawReport.Departments?.[0]?.Users?.[0]?.Absences?.Absences || [];
        const columns = this.parseColumns();
        this.clearLocalData();
        return columns;
    }
    static parseColumns() {
        const columns = [];
        columns.push(userDataColumnGroup);
        columns.push(periodNormColumnGroup);
        columns.push(individualNormColumnGroup);
        columns.push(userActualColumnGroup);
        columns.push(workTimeColumnGroup);
        columns.push(this.getWorksColumnGroup());
        columns.push(freeTimeColumnGroup);
        columns.push(freeDaysColumnGroup);
        columns.push(...this.getAbsencesColumnGroups());
        return columns;
    }
    static getWorksColumnGroup() {
        const columns = [
            ...this.parseDynamicColumns(this.dynamicWorksSource, DYN_FLAG.WORK),
            trainingColumn,
            extraWorkColumn,
            ...this.parseDynamicColumns(this.dynamicExtrasSource, DYN_FLAG.EXTRA),
            watchColumn,
            overUnderColumn,
            contractOverUnderColumn
        ];
        return {
            name: ColumnGroupTypes.CalculatedWorkHours,
            showName: true,
            key: ColumnGroupTypes.CalculatedWorkHours,
            columns
        };
    }
    static parseDynamicColumns(source, keyFlag) {
        const columns = [];
        source.forEach((dynamicWork, idx) => {
            columns.push({
                name: dynamicWork.Name,
                shortName: dynamicWork.ShortenedName,
                noTranslate: true,
                key: `${decapitalize(dynamicWork.Name)}-${keyFlag}-${idx}`,
                columnGroup: ColumnGroupTypes.CalculatedWorkHours,
                valueExtractor: (row) => row.workHours[`${decapitalize(dynamicWork.Name)}-${keyFlag}`],
                cellClassNames: 'text-right'
            });
        });
        return columns;
    }
    static getAbsencesColumnGroups() {
        const columnGroups = [];
        this.absencesSource.forEach((absence, idx) => {
            const columnGroup = {
                name: absence.Name,
                showName: true,
                key: `${decapitalize(absence.Name)}-${idx}`,
                noTranslate: true,
                columns: this.getAbsenceGroupColumns(absence, idx)
            };
            columnGroups.push(columnGroup);
        });
        return columnGroups;
    }
    static getAbsenceGroupColumns(absence, idx) {
        const daysColumn = {
            name: 'Days',
            key: `${decapitalize(absence.Name)}-days-${idx}`,
            shortName: absence.ExternalCode || 'N/A',
            columnGroup: ColumnGroupTypes.Absences,
            valueExtractor: (row) => row.absences[decapitalize(absence.Name)]?.days || '0',
            cellClassNames: 'text-right'
        };
        const hoursColumn = {
            name: 'Hours',
            key: `${decapitalize(absence.Name)}-hours-${idx}`,
            shortName: absence.ExternalCode || 'N/A',
            columnGroup: ColumnGroupTypes.Absences,
            valueExtractor: (row) => row.absences[decapitalize(absence.Name)]?.duration,
            cellClassNames: 'text-right'
        };
        return [daysColumn, hoursColumn];
    }
    static clearLocalData() {
        this.dynamicWorksSource = [];
        this.dynamicExtrasSource = [];
        this.absencesSource = [];
    }
}
export default ColumnGroupsParser;
